import { useEffect, useState } from "react"
import { StandardButton } from "../atoms/buttons"
import { StandardComp } from "../atoms/standardComp"
import { OrderRow, TitleOrder } from "../molecule/orderRow"
import { TitleDescription } from "./titleDescription"
import { VerticalLayout } from "./layout"
import { getAPI } from "../api/api"

export const OrderComp = ({ order }) => {
    const [orderDetails, setOrderDetails] = useState({ number:1231,total_modules:20000, total_value:0.2, date:"12-05-2024", title: "Aantal modules", description: "Totaal aantal modules afgenomen", "value": 200000, discount: 10, couponCode: "2ff" })

    return (
        <StandardComp
            editClass={"order-top-comp"}
            style={{width:"100%", "boxSizing": "border-box"}}
            content={
                <VerticalLayout>
                    <TitleOrder detail={order}/>
                    <OrderRow detail={{"title":"Aantal modules", description:"Totaal aantal modules dat is besteld"}} value={order.total_modules}  />
                    <OrderRow value={order.total_value} className={"border-order-comp"} detail={{ title: "Kosten module", description: `Totaal voordeel per module: `, value: orderDetails.discount }} />
                    <OrderRow detail={{ title: "Totale kosten" }}  value={ order.total_cost}/>
                </VerticalLayout>



            }
        />
    )
}